export default __webpack_public_path__ + "static/media/Mark-5-Blueprints-01.18d47e46.jpg";